/**
 * Promotions Routes.
 */
export const promotions = {
  featureTour: '/promotions/feature-tour',
  productTour: '/promotions/product-tour',
}
